import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the billing-settings Heidi II complimentary usage banner.
 *
 * Cast until ml-scribe `shared/enums/modal_tracking.py` (GRO-4483) is deployed
 * and `pnpm run schema:dev` picks it up; then swap the cast for `ModalId.X`.
 * The string is frozen — it keys `seen_modals`.
 */
export const COMPLIMENTARY_USAGE_BANNER_MODAL_ID =
  'T4_CUSTOM_AUDIENCE_HEIDI_2_SETTINGS_COMPLIMENTARY_BANNER' as ModalId;
